// extracted by mini-css-extract-plugin
module.exports = {"root":"FormError_root__o1SVD"};